import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'lessThanTen' })
export class LessThanTenPipe implements PipeTransform {
    transform(value: number) {
        return (value < 10)
            ? `<${10}`
            : ` ${value}`;
    }
}